import { BaseRouteService } from 'core/services';

class CoreUserRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'users-in-organization/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	findByUserName(username, options) {
		return super.get('users/{id}/{?embed}', username, options);
	}

	delete() {
		return super.delete(this.base);
	}
}

export default CoreUserRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/CoreUserRouteService.js